<template>
  <span class="toggle-switch">
    <label class="switch" :class="{ 'disabled': value }">
      <input 
        type="checkbox" 
        :checked="value" 
        @click.prevent="handleClick"
        :disabled="value"
      >
      <span class="slider" :class="{ active: value }">
        <span class="circle-text">
          {{ value ? 'On' : 'Off' }}
        </span>
      </span>
    </label>
  </span>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('change', !this.value);
    }
  }
};
</script>

<style scoped>
/* Container */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 32px;
}

.switch.disabled {
  cursor: not-allowed;
}

/* Hidden default checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e9ecef; /* Off state */
  border-radius: 32px;
  transition: 0.4s;
}

.slider.active {
  cursor: not-allowed;
}

/* Circle */
.slider::before {
  content: "";
  position: absolute;
  height: 26px;
  width: 26px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
  border: 1px solid #ccc;
}

/* Text inside the circle */
.circle-text {
  position: absolute;
  width: 26px;
  height: 26px;
  left: 3px;
  bottom: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: #000;
  pointer-events: none;
  transition: 0.4s;
}

/* On State */
input:checked + .slider {
  background-color: #8b0000; /* Dark red */
}

input:checked + .slider::before {
  transform: translateX(28px);
  border-color: #8b0000;
}

input:checked + .slider .circle-text {
  transform: translateX(28px);
  color: #8b0000;
}
</style>
